module.exports = __webpack_public_path__ + "img/customer4.c2bb8ad6.png";